import { isXSell } from "@fdr/utils/mobileUtils";
import { ENV_KEYS } from "../../constants";

export const EXPERIMENT_KEY =
  "qfd-319-changing-the-order-of-todays-popular-races-and-races-starting-soon";

export const DEPLOYMENT_KEY = isXSell()
  ? ENV_KEYS.fdr_fe.xsell
  : ENV_KEYS.fdr_fe.cpe_web;
